import React from "react";
import { Fade } from "react-awesome-reveal";
import "./Contact.scss";

function Contact() {
  return (
    <div className="cantact-wrap">
      <div className="col-md-4 ">
        <Fade>
          <div className="detail-wrap d-flex">
            <div className="detail-icon">
              <span>
                {" "}
                <i className="fa-solid fa-location-dot"></i>
              </span>
            </div>
            <div className="details-text">
              <h5 className="heading-black">Address</h5>
              <p>
                {/* 7/1, Ground Floor, Nand Puri, Kanker Khera Meerut Cantt, Meerut, */}
                Nand Puri, Kanker Khera Meerut Cantt, Meerut, India, 250001
              </p>
            </div>
          </div>
        </Fade>
      </div>
      <div className="col-md-4 ">
        <Fade>
          <div className="detail-wrap d-flex">
            <div className="detail-icon">
              <span>
                {" "}
                <i className="fa-regular fa-envelope"></i>{" "}
              </span>
            </div>
            <div className="details-text">
              <h5 className="heading-black">Email Us</h5>
              <p>
                <a href="mailto:wowwishMoments@gamail.com">
                  wowWishMoments@gmail.com
                </a>
              </p>
              <p>
                <a href="https://wa.me/919758635932">Whatsapp Me</a>
              </p>
            </div>
          </div>
        </Fade>
      </div>
      <div className="col-md-4 ">
        <Fade>
          <div className="detail-wrap d-flex">
            <div className="detail-icon">
              <span>
                {" "}
                <i className="fa-solid fa-phone"></i>
              </span>
            </div>
            <div className="details-text">
              <h5 className="heading-black">Call Us</h5>
              <p>
                <a href="tel:+919758635932">+91-9758635932 </a> &nbsp; &nbsp;
                <a href="tel:+919758635932">+91-7017795995</a>
              </p>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}

export default Contact;
